import React, { useRef } from "react";
import { SocketContext, socket } from "../../context/socket";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Alert,
  Form,
  TextArea,
  Button,
  FormFeedback,
  Label,
  InputGroup,
} from "reactstrap";

import { connect } from "react-redux";
//i18n
import i18n from "../../i18n";
//i18n
import { useTranslation } from "react-i18next";

//Import Components
import LanguageSelector from "../../components/LanguageSelector";
import ThemeSwitcher from "../../components/ThemeSwitcher";
import Spinner from "../../components/ButtonSpinner";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Import Images
import logodark from "../../assets/images/logo-dark.png";
import logolight from "../../assets/images/logo-light.png";

const Setup = React.memo((props) => {
  /* intilize t variable for multi language implementation */
  const { t } = useTranslation();
  const codePane = useRef();
  let embedCode = `
<!-- EMBED ATCHR WIDGET -->
<script type="text/javascript">
  (function() {
    var elem = document.createElement("script"),
    frame = document.getElementsByTagName("script")[0];
    elem.async = true;
    elem.src = 'https://embed.atchr.com/${props.match.params.unique}';
    elem.charset = 'UTF-8';
    elem.setAttribute('scrolling', 'no');
    elem.setAttribute('allowTransparency', 'true');
    frame.parentNode.insertBefore(elem, frame);
  })();
</script>
<!-- END WIDGET -->
`;
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success(t("Message copied to clipboard."), {
      theme: document.getElementsByTagName("BODY")[0].dataset.theme,
    });
  };

  const routeChange = (path = null) => {
    window.location.href = path || "/";
  };

  return (
    <React.Fragment>
      <SocketContext.Provider value={socket}>
        <div className="account-pages mt-5 pt-sm-5 pt-md-0">
          <div className="faux-menu">
            <ThemeSwitcher />
            <LanguageSelector />
          </div>
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <div className="text-center mb-3">
                  <Link
                    to="/"
                    onClick={() => routeChange("/")}
                    className="auth-logo mb-2 d-block"
                  >
                    <img
                      src={logodark}
                      alt=""
                      height="50"
                      className="logo logo-dark"
                    />
                    <img
                      src={logolight}
                      alt=""
                      height="50"
                      className="logo logo-light"
                    />
                  </Link>

                  {/*<h4>{t('Embed Widget')}</h4>*/}
                </div>
                <Card>
                  <CardBody className="px-4 py-2">
                    {props.error && (
                      <Alert className="mb-0" variant="danger">
                        {props.error}
                      </Alert>
                    )}
                    <div className="p-3">
                      <div className="mb-3">
                        <Label className="form-label">
                          {t("Embed Widget")}
                        </Label>
                        <textarea
                          style={{ height: "285px" }}
                          className="form-control form-control-lg bg-soft-light border-light font-monospace font-size-10 overflow-hidden"
                          rows="6"
                          readOnly
                          ref={codePane}
                          value={embedCode}
                        ></textarea>
                      </div>
                      <p className="text-muted mb-2 small">
                        {t(
                          "Paste this embed code at the bottom of your page and save your code."
                        )}
                      </p>
                      <div className="d-grid">
                        <Button
                          color="primary"
                          className="waves-effect waves-light"
                          onClick={() => copyToClipboard(embedCode)}
                          type="submit"
                        >
                          <i className="ri-file-copy-line"></i> {t("Copy")}
                        </Button>
                      </div>
                      <div className="d-grid mt-3">
                        <Link
                          to="/"
                          onClick={() => routeChange("/")}
                          className="text-center"
                        >
                          {t("Done")}
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-4 text-center">
                  <p>
                    &copy;{props.currentYear} {t("Atchr")}. &#10084;{" "}
                    {t("by Chromesque")}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </SocketContext.Provider>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  );
});

const mapStateToProps = (state) => {
  const { currentYear } = state.Misc;
  return { currentYear };
};

export default connect(mapStateToProps, {})(Setup);
